import { render, staticRenderFns } from "./LayoutColumnComponent.vue?vue&type=template&id=07b4bea9&scoped=true&"
import script from "./LayoutColumnComponent.vue?vue&type=script&lang=js&"
export * from "./LayoutColumnComponent.vue?vue&type=script&lang=js&"
import style0 from "./LayoutColumnComponent.vue?vue&type=style&index=0&id=07b4bea9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b4bea9",
  null
  
)

export default component.exports